// 電話番号
export const TEL_NUMBER = "0120-482-488";
